export default __webpack_public_path__ + "static/media/1.55e93bc7.png";